import { useTrackedSWRKey as e } from "./use-revalidate-modules.mjs";
import { useCallback as t, useRef as n } from "react";
import r from "swr";
//#region src/hooks/use-controlled-swr.ts
var i = (i, a, o, s = !0) => {
	e(i);
	let c = n(void 0), l = t(() => c.current?.abort(), []);
	return {
		...r(s ? i : void 0, (e) => {
			let t = Array.isArray(e) ? e[0] : e;
			return c.current = new AbortController(), a?.(t, { signal: c.current.signal });
		}, o),
		abort: l
	};
};
//#endregion
export { i as useControlledSwr };
